export enum HIGHLIGHT_COLOR_NAMES {
	YELLOW = "yellow",
	GREEN = "green",
	PURPLE = "purple",
	BLUE = "blue",
	ORANGE = "orange",
	RED = "red",
}

export const HIGHLIGHT_DOCX_NAMES: Record<HIGHLIGHT_COLOR_NAMES, string> = {
	[HIGHLIGHT_COLOR_NAMES.YELLOW]: "yellow",
	[HIGHLIGHT_COLOR_NAMES.GREEN]: "green",
	[HIGHLIGHT_COLOR_NAMES.PURPLE]: "purple",
	[HIGHLIGHT_COLOR_NAMES.BLUE]: "blue",
	[HIGHLIGHT_COLOR_NAMES.ORANGE]: "orange",
	[HIGHLIGHT_COLOR_NAMES.RED]: "red",
};

export const MAP_OLD_HIGHLIGHTS_TO_NEW: Record<string, HIGHLIGHT_COLOR_NAMES> = {
	peony: HIGHLIGHT_COLOR_NAMES.YELLOW,
	cinnamon: HIGHLIGHT_COLOR_NAMES.GREEN,
	honey: HIGHLIGHT_COLOR_NAMES.PURPLE,
	mint: HIGHLIGHT_COLOR_NAMES.BLUE,
	turquoise: HIGHLIGHT_COLOR_NAMES.ORANGE,
	marine: HIGHLIGHT_COLOR_NAMES.RED,
	plume: HIGHLIGHT_COLOR_NAMES.YELLOW,
	"lemon-yellow": HIGHLIGHT_COLOR_NAMES.YELLOW,
	"mint-green": HIGHLIGHT_COLOR_NAMES.GREEN,
	lavender: HIGHLIGHT_COLOR_NAMES.PURPLE,
	"ice-blue": HIGHLIGHT_COLOR_NAMES.BLUE,
	peach: HIGHLIGHT_COLOR_NAMES.ORANGE,
	"light-pink": HIGHLIGHT_COLOR_NAMES.PURPLE,
	"grayish-blue": HIGHLIGHT_COLOR_NAMES.BLUE,
};
